var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "align-center": "", "justify-start": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs9: "" } },
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-autocomplete",
                        _vm._g(
                          {
                            attrs: {
                              items: _vm.freightClasses,
                              value: _vm.value
                            },
                            on: {
                              input: function(v) {
                                return _vm.$emit("input", v)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(
                                                      propsActivator
                                                    ) {
                                                      return [
                                                        _c(
                                                          "v-list-tile-title",
                                                          _vm._g(
                                                            {},
                                                            propsActivator.on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item.text
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    props.item.description
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          on
                        )
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.currentItem.description || _vm.$t("noDataAvailable")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            attrs: { "ma-0": "", small: "", icon: "" },
                            on: { click: _vm.calFreightClass }
                          },
                          on
                        ),
                        [_c("v-icon", [_vm._v("calculate")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("calculateFreightClass")) + "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0941d008", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0941d008","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelFreightClassSelector.vue
// module id = null
// module chunks = 